import { useCallback, useEffect, useSyncExternalStore } from 'react';
import {
  getThemeState, retainTheme, setThemePreference, subscribeTheme, type ResolvedTheme, type ThemePreference,
} from './themeStore';

export interface UseTheme {
  /** What the person chose: light, dark or system. */
  preference: ThemePreference;
  /** What is on screen now (System resolved against the device). */
  resolved: ResolvedTheme;
  setPreference: (p: ThemePreference) => void;
}

/** The theme preference. Holds the live listeners (device scheme, other tabs) for as long as the caller is mounted. */
export function useTheme(): UseTheme {
  const snap = useSyncExternalStore(subscribeTheme, getThemeState, getThemeState);
  useEffect(() => retainTheme(), []);
  const setPreference = useCallback((p: ThemePreference) => setThemePreference(p), []);
  return { preference: snap.preference, resolved: snap.resolved, setPreference };
}
